export function loguin(usuario){return {type:'loguin',payload:usuario} };
export function usuario(usuario){return {type:'usuario',payload:usuario} };
export function data(data){return {type:"setData",payload:data}};
export function dataRutas(data){return {type:"setDataRutas",payload:data}};
export function logout(){return {type:'logout'} }; 
export function grupoSelected(grupo){return {type:'grupo', payload:grupo}};
export function SpeedTestResult(result){return {type:'speedTest', payload:result}};
export function runTest(result){return {type:'runTest', payload:result}};
export function hardwareDetail(value){return {type:'hardware', payload:value}};
export function instal(valor){return {type:'instal', payload:valor}};
export function urlVideo(valor){return {type:'urlvideo', payload:valor}};
export function open(valor){return {type:'open', payload:valor}};
export function setId(valor){return {type:'id', payload:valor}};
export function setIdCopy(valor){return {type:'idCopy', payload:valor}};
export function setStp(valor){return {type:'setStep', payload:valor}};
export function setNroRuta(valor){return {type:'nroRuta', payload:valor}};
export function setMenuRuta(valor){return {type:'menuRutas', payload:valor}};
export function setBusqueda(valor){return {type:'busqueda', payload:valor}};
